import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Observable, Subscription } from "rxjs/Rx";
import { map } from "rxjs/operators";
import { AuthenticationService, MissionService, DataStore } from "../_services";
import { Router } from "@angular/router";
import { ThingsSyncService } from "src/app/_services/thingsSync.service";


import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MatSidenavModule, MatSidenav } from '@angular/material/sidenav';
import { HTTPCallsService } from '../_services/http.service';


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"]
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav', { static: false }) sidenav: MatSidenav;
  close() {
    this.sidenav.close();
  }
  userName: any;
  placeNameSet = new Set();
  loading: boolean;
  timerSubscription: Subscription;
  timerCheck: Subscription;
  data: string;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private authenticationService: AuthenticationService,
    private missionService: MissionService,
    private thingSyncService: ThingsSyncService,
    private router: Router,
    private dataStore: DataStore,
    private dbService: NgxIndexedDBService,
    private httpService: HTTPCallsService
  ) { }
  ngOnInit() {
    this.name();
    this.placeNameSet.clear()
    this.refreshData();
    this.loading = true;
    this.thingSyncService.syncThingsData(1);

    this.missionService.missionAnnounced$.subscribe(mission => {
      switch (mission) {
        case "LocationListFramed":

          this.name();
          break;
      }
    });
    let name = JSON.parse(localStorage.getItem("currentUser"));

    this.userName = name["userName"];
    this.getProfilePicture(name["phoneNumber"]);
  }

  onSearchChange(searchValue: string): void {
    this.getPlaceNameDevices(searchValue.toLowerCase());
  }
  private refreshData(): void {
    this.thingSyncService.syncThingsData(1);

    this.subscribeToData();
  }
  private subscribeToData(): void {
    this.timerSubscription = Observable.timer(3000)
      .first()
      .subscribe(() => { this.refreshData() });
  }
  name() {

    this.dbService.getAll('locationList').then(data => {
      data.forEach(element => {
        if (element['name'] != "")
          this.placeNameSet.add(element['name'])


      });
      this.loading = false

    })

  }
  getPlaceNameDevices(placeName) {
    this.router.navigate(["/dashboard/things/" + placeName]);
    this.missionService.announceMission("sort!#!" + placeName);
  }
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  navigateTo(routesID: string) {
    // console.log("Navigating to ", routesID);

    switch (routesID) {
      case "things":

        this.router.navigate(["/dashboard/things"]);
        this.missionService.announceMission("removeSort");
        break;
      case "access":
        this.router.navigate(["/dashboard/access"]);
        break;
      case "settings":
        this.router.navigate(["/dashboard/settings"]);
        break;
      case "logout":
        this.authenticationService.logout();
        break;
    }
  }

  logout() {
    this.loading = false
    this.authenticationService.logout();

  }
  getProfilePicture(phoneNumber) {
    this.httpService.getProfileIcon(phoneNumber).subscribe((data) => {
      this.data = data;
    }, (error) => {
      console.log('Error ', error);
    });
  }
  ngOnDestroy(): void {
    this.timerSubscription.unsubscribe();

    this.timerCheck = Observable.timer(10000).first()
      .subscribe(() => {
        this.timerSubscription.unsubscribe()
        this.dataStore.deleteDatabase()
      });
  }
}
